import { useCallback } from "react";
import { getTokenDecimals } from "../store/global/getAllowances";
import { GlobalStore } from "../store/global/GlobalStore";
import { Token } from "../store/global/TokenEnum";

export const useGetTokenDecimals = () => {
  const tokenMetadata = GlobalStore.useState(s => s.tokens);
  return useCallback((symbol: Token) => getTokenDecimals(symbol, tokenMetadata), [tokenMetadata]);
};
